import React, { Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import Header from './Header';
import Homepage from './HomePage';
import PostSplitter from '../Tools/PostSplitter/PostSplitter';
import PrivacyPolicy from './PrivacyPolicy';
import TermsConditions from './TermsConditions';
import ScrollToTop from './shared/ScrollToTop';
import ProvideFeedbackPage from "./shared/ProvideFeedbackPage";

// Lazy load tool components
const SentimentAnalyzer = React.lazy(() => import('../Tools/Sentiment/SentimentAnalyzer'));
const HashtagsAnalyzer = React.lazy(() => import('../Tools/Hashtags/HashtagsAnalyzer'));
const EmojisAnalyzer = React.lazy(() => import('../Tools/Emojis/EmojisAnalyzer'));
const AITextAnalyzer = React.lazy(() => import('../Tools/DetectAI/AITextAnalyzer'));
const ReadabilityAnalyzer = React.lazy(() => import('../Tools/ReadabilityChecker/ReadabilityAnalyzer'));
const TextSummarizationAnalyzer = React.lazy(() => import('../Tools/Summarization/TextSummarizationAnalyzer'));
const KeywordExtractionAnalyzer = React.lazy(() => import('../Tools/KeywordExtraction/KeywordExtractionAnalyzer'));
const SemanticSimilarityAnalyzer = React.lazy(() => import('../Tools/SemanticSimilarity/SemanticSimilarityAnalyzer'));

// Loading component
const LoadingSpinner = () => (
  <div style={{ 
    display: 'flex', 
    justifyContent: 'center', 
    alignItems: 'center', 
    height: '50vh',
    fontSize: '1.2rem',
    color: '#666'
  }}>
    Loading...
  </div>
);

export default function Paperbase() {
    return (
        <>
        <ScrollToTop />
        <Header />
        <Suspense fallback={<LoadingSpinner />}>
            <Routes>
                <Route path="/" element={<Homepage />} />
                <Route path="/PostSplitter" element={<PostSplitter />} />
                <Route path="/SentimentAnalyzer" element={<SentimentAnalyzer />} />
                <Route path="/HashtagsAnalyzer" element={<HashtagsAnalyzer />} />
                <Route path="/EmojisAnalyzer" element={<EmojisAnalyzer />} />
                <Route path="/AITextAnalyzer" element={<AITextAnalyzer />} />
                <Route path="/ReadabilityAnalyzer" element={<ReadabilityAnalyzer />} />
                <Route path="/TextSummarizationAnalyzer" element={<TextSummarizationAnalyzer />} />
                <Route path="/KeywordExtractionAnalyzer" element={<KeywordExtractionAnalyzer />} />
                <Route path="/SemanticSimilarityAnalyzer" element={<SemanticSimilarityAnalyzer />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/terms-and-conditions" element={<TermsConditions />} />
                <Route path="/provide-feedback" element={<ProvideFeedbackPage />} />
            </Routes>
        </Suspense>
        </>
    );
}
